<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    flattenedUsers: (flattenedUsers$ | async) ?? []
  }"
>
</ng-container>

<ng-template #template let-flattenedUsers="flattenedUsers">
  <ng-container *ngIf="flattenedUsers">
    <mat-toolbar *ngIf="flattenedUsers.length">
      <span>{{ "Assigned Users" }}</span>
    </mat-toolbar>
    <vp-users-list
      [users]="flattenedUsers"
      [columnsToDisplay]="displayedColumns"
      [isRouterLinkEnabled]="false"
    ></vp-users-list>
  </ng-container>
</ng-template>
